<template>
	<KkAccessibleButton
		class="kk-button-base"
		:class="{
			'kk-button-base--full-width': isFullWidth,
			'kk-button-base--enabled': !isDisabled && !isLoading,
			'kk-button-base--disabled': isDisabled,
			'kk-button-base--loading': isLoading,
		}"
		:tabindex="isClickForbidden ? null : 0"
		@click="click"
	>
		<div
			v-if="$slots.leading"
			class="kk-button-base__leading"
		>
			<slot name="leading" />
		</div>
		<div
			v-if="$slots.body"
			class="kk-button-base__body"
		>
			<slot name="body" />
		</div>
		<div
			v-if="$slots.trailing"
			class="kk-button-base__trailing"
		>
			<slot name="trailing" />
		</div>
		<div
			v-show="isLoading"
			class="kk-button-base__spinner"
		>
			<slot name="spinner" />
		</div>
	</KkAccessibleButton>
</template>

<script>
export default {
	name: 'KkButtonBase',
}
</script>
<script setup>
import KkAccessibleButton from '../../KkAccessibleButton';
import {computed} from 'vue';

const emits = defineEmits(['click']);
const props = defineProps({
	isFullWidth: {
		type: Boolean,
		default: false,
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	isLoading: {
		type: Boolean,
		default: false,
	},
	isClickBypassLimit: {
		type: Boolean,
		default: false,
	},
})

const isClickForbidden = computed(() => props.isDisabled || props.isLoading);

const click = () => {
	if (isClickForbidden.value && !props.isClickBypassLimit) {
		return;
	}
	emits('click');
}
</script>
